// src/slices/auditLogs/thunk.ts
// Async thunks for Audit Logs

import { createAsyncThunk } from '@reduxjs/toolkit';
import { getAuditLogs } from 'helpers/fakebackend_helper';
import { GetAuditLogsParams } from 'pages/AuditLogs/types';

export const fetchAuditLogs = createAsyncThunk(
  'AuditLogs/fetchAuditLogs',
  async (params: GetAuditLogsParams, { rejectWithValue }) => {
    try {
      const response = await getAuditLogs(params);
      return response.data || response;
    } catch (error: any) {
      return rejectWithValue(
        error?.message || 'Có lỗi xảy ra khi tải dữ liệu audit logs'
      );
    }
  }
);